import React from 'react';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import {
    PAGE_OUTER_PADDING,
    PAGE_OUTER_PADDING_TOP,
    PAGE_OUTER_PADDING_X,
    RAPCHIK_BLURRED_BG_OVERLAY_STYLE,
} from '../../constants/housieLiveStyles';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';
import TopHeader from './TopHeader';
import AppFooter from './AppFooter';

const resolveContentPadding = (padding, disablePadding) => {
    if (disablePadding) {
        return {
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
        };
    }

    if (padding && typeof padding === 'object' && !Array.isArray(padding)) {
        const top = padding.top ?? PAGE_OUTER_PADDING_TOP;
        const x = padding.x ?? PAGE_OUTER_PADDING_X;
        const bottom = padding.bottom ?? top;
        return {
            paddingTop: top,
            paddingRight: x,
            paddingBottom: bottom,
            paddingLeft: x,
        };
    }

    // Default / numeric: 20px top/bottom, 25px left/right
    const vertical =
        typeof padding === 'number' ? padding : PAGE_OUTER_PADDING_TOP;
    return {
        paddingTop: vertical,
        paddingRight: PAGE_OUTER_PADDING_X,
        paddingBottom: vertical,
        paddingLeft: PAGE_OUTER_PADDING_X,
    };
};

/**
 * Background component
 * Full-app pastel glass theme with children
 */
export default function Background({
    children,
    padding = PAGE_OUTER_PADDING,
    disablePadding = false,
    style = {},
    isShowHeader = true,
    isBreadcrumbVisible = false,
    breadCrumbShowBack = true,
    breadCrumbOnBack,
    breadCrumbItems = [],
    isShowRapFireLeaderboardSpotlight = false,
    showBlurredBg = false,
    showText = false,
}) {
    const WINNER_PODIUM_SPOTLIGHT_IMAGE = IMAGE_CONSTANTS.WINNER_PODIUM_SPOTLIGHT;
    const contentPadding = resolveContentPadding(padding, disablePadding);

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 0,
                overflow: 'hidden',
                backgroundColor: 'transparent',
                color: COLORS_CONSTANTS.PAGE_TEXT,
                ...style,
            }}
        >
            {/* Figma 18011:22154 — bg blured */}
            {showBlurredBg ? (
                <div aria-hidden="true" style={RAPCHIK_BLURRED_BG_OVERLAY_STYLE} />
            ) : null}

            <div
                style={{
                    ...contentPadding,
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    zIndex: 1,
                    boxSizing: 'border-box',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {isShowRapFireLeaderboardSpotlight && (
                    <img
                        src={WINNER_PODIUM_SPOTLIGHT_IMAGE}
                        alt="WINNER_PODIUM_SPOTLIGHT_IMAGE"
                        style={{
                            position: 'absolute',
                            top: 0,
                            width: '60%',
                            zIndex: -1,
                            justifyContent: 'center',
                            alignItems: 'center',
                            left: '50%',
                            transform: 'translateX(-50%)',
                        }}
                    />
                )}

                {isShowHeader && (
                    <TopHeader
                        isBreadcrumbVisible={isBreadcrumbVisible}
                        breadCrumbShowBack={breadCrumbShowBack}
                        breadCrumbOnBack={breadCrumbOnBack}
                        breadCrumbItems={breadCrumbItems}
                    />
                )}
                <div style={{ flex: '1 0 auto', minHeight: 0, width: '100%' }}>
                    {children}
                </div>
                {/* Figma 18055:23259 — footer in document flow, scrolls with page */}
                {showText ? <AppFooter /> : null}
            </div>
        </div>
    );
}
